<loader
  title="Verifying, do not exit this page..."
  [loading]="loading"
></loader>
